import {createSlice, type PayloadAction} from "@reduxjs/toolkit";

/** Which rows the object input pages show, switched by the toolbar of the overview tab. */
export type ObjectDisplayStatus = "default" | "all" | "required";

interface UiPreferencesState {
    /**
     * Display status of the object parameter view ("default" | "all" | "required").
     * null = not yet initialized for the loaded valuation — PageObject then derives
     * the initial value from the valuation type (BlueHorizon → "required"). (#18983)
     */
    objectDisplayStatus: ObjectDisplayStatus | null;
}

const initialState: UiPreferencesState = {
    objectDisplayStatus: null,
};

/**
 * Session-only UI preferences. They live in the Redux store so they survive switching
 * between the main pages (which unmounts the page components), but they are neither
 * persisted to the server nor to localStorage — a reload starts fresh.
 */
export const uiPreferencesSlice = createSlice({
    name: "uiPreferences",
    initialState,
    reducers: {
        setObjectDisplayStatus: (state, action: PayloadAction<ObjectDisplayStatus | null>) => {
            state.objectDisplayStatus = action.payload;
        },
        resetUiPreferences: (state) => {
            state.objectDisplayStatus = null;
        },
    },
    selectors: {
        /** the chosen object parameter view, or null before initialization */
        selectObjectDisplayStatus: (state) => state.objectDisplayStatus,
    },
});

export const {setObjectDisplayStatus, resetUiPreferences} = uiPreferencesSlice.actions;

export const {selectObjectDisplayStatus} = uiPreferencesSlice.selectors;

export default uiPreferencesSlice.reducer;
